// import { getAuth } from 'firebase/auth';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import app from "@/firebase-app";
import {
  getAuth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail
} from 'firebase/auth';
// import { onAuthStateChanged } from "firebase/auth";
// import { setPersistence, browserLocalPersistence } from "firebase/auth";

export default {
  namespaced: true,
  state() {
    return {
      freshAuth: false,
      token: null,
      userId: null,
      profileBlob: null,
      profileBlobUrl: null,
      userInfo: {},
    };
  },
  mutations: {
    setProfileBlobUrl(state, payload) {
      state.profileBlobUrl = payload;
    },
    setProfileBlob(state, payload) {
      state.profileBlob = payload;
    },
    setUserObject(state, payload) {
      state.userObject = payload;
    },
    setUser(state, payload) {
      state.token = payload.token;
      state.userId = payload.userId;
      state.userInfo = payload.userInfo;
    },
    setGettingStarted(state, payload) {
      state.userInfo.profilePic = payload.profilePic;
      state.userInfo.spot1 = payload.spot1;
      state.userInfo.spot2 = payload.spot2;
      state.userInfo.otherContactInfo = payload.otherContactInfo;
    },
    setFreshAuth(state, rec) {
      state.freshAuth = rec;
    },
    setTestUser(state) {
      state.userId = 'c1';
      state.firstName = 'Mustafa';
      state.lastName = 'Gurkan';
      state.emailAddress = 'mustafa@testuser.com';
      state.phoneNumber = '0553 447 88 92';
      state.otherContactInfo.whatsApp = '0553 447 88 92';
      state.otherContactInfo.telegram = '0553 447 88 92';
      state.dateOfBirth = '5/3/1988';
      state.gender = 'male';
    },
    logoutTestUser(state) {
      state.userId = null;
      state.firstName = '';
      state.lastName = '';
      state.emailAddress = '';
      state.phoneNumber = '';
      state.otherContactInfo.whatsApp = null;
      state.otherContactInfo.telegram = null;
      state.dateOfBirth = null;
      state.gender = null;
    },
  },
  actions: {
    async signup(context, payload) {
      const email = payload.email;
      const password = payload.password;
      delete payload.password;
      try {
        const auth = await getAuth();
        const signupRes = await createUserWithEmailAndPassword(
          auth,
          email,
          password
        );
        const idToken = await signupRes.user.getIdToken(true);
        const userId = signupRes.user.toJSON().uid;
        context.commit('setAuth');

        try {
          await fetch(
            `https://real-shop-test-default-rtdb.asia-southeast1.firebasedatabase.app/users/${userId}.json`,
            {
              method: 'PUT',
              body: JSON.stringify(payload),
            }
          );
          context.commit('setFreshAuth', true);
          context.commit('setUser', {
            userId: userId,
            token: idToken,
            userInfo: payload,
          });
          localStorage.setItem('idToken', idToken);
          localStorage.setItem('userId', userId);
          localStorage.setItem('userInfo', JSON.stringify(payload));
        } catch (err) {
          const error = new Error("couldn't fetch userInfo, try again");
          error.name = 'fetch';
          throw error;
        }
      } catch (error) {
        if (error.message.includes('email-already-in-use')) {
          const error = new Error('email already exist');
          error.name = 'exist';
          throw error;
        }
        throw error;
      }
    },
    async getStarted(context, payload) {
      const storage = getStorage(app);
      const cRef = ref(storage, 'profiles/' + `${context.getters.getUserId}` + '/profile');
      await uploadBytes(cRef, context.getters.getProfileBlob);

      const url = await getDownloadURL(cRef);

      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = () => {
        const objUrl = URL.createObjectURL(xhr.response);
        context.commit('setProfileBlobUrl', objUrl)
      };
      xhr.open('GET', url);
      xhr.send();

      const temp = {
        profilePic: url,
        otherContactInfo: payload.otherContactInfo,
        spot1: payload.spot1,
        spot2: payload.spot2,
      };
      context.commit('setGettingStarted', temp);
      const userInfo = context.getters.getUserInfo;
      const userId = context.getters.getUserId;

      await fetch(
        `https://real-shop-test-default-rtdb.asia-southeast1.firebasedatabase.app/users/${userId}.json`,
        {
          method: 'PUT',
          body: JSON.stringify(userInfo),
        }
      );
      localStorage.removeItem('userInfo');
      localStorage.setItem('userInfo', JSON.stringify(userInfo));
      context.commit('setFreshAuth', false);
    },
    async login(context, payload) {

      try {
        const auth = await getAuth();
        const loginRes = await signInWithEmailAndPassword(
          auth,
          payload.email,
          payload.password
        );
        const token = await loginRes.user.getIdToken(true);
        const userId = loginRes.user.toJSON().uid;
        context.commit('setAuth', auth);

        try {
          const loginUserGetDataResponse = await fetch(
            `https://real-shop-test-default-rtdb.asia-southeast1.firebasedatabase.app/users/${userId}.json`
          );
          const userInfo = await loginUserGetDataResponse.json();
          context.commit('setUser', {
            userId: userId,
            token: token,
            userInfo: userInfo,
          });

          const xhr = new XMLHttpRequest();
          xhr.responseType = "blob";
          xhr.onload = () => {
            const objUrl = URL.createObjectURL(xhr.response);
            context.commit('setProfileBlobUrl', objUrl)
          };
          xhr.open('GET', userInfo.profilePic);
          xhr.send();

          localStorage.setItem('idToken', token);
          localStorage.setItem('userId', userId);
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          context.commit('setFreshAuth', false);
        } catch (err) {
          const error = new Error("couldn't fetch userInfo, try again");
          error.name = 'fetch';
          throw error;
        }
      } catch (error) {
        if (error.message.includes('user-not-found')) {
          const error = new Error('no such email registered');
          error.name = 'found';
          throw error;
        } else if (error.message.includes('wrong-password')) {
          const error = new Error('incorrect password');
          error.name = 'invalid';
          throw error;
        }
        throw error;
      }
    },
    async logout(context) {
      const auth = getAuth();
      await signOut(auth);
      localStorage.removeItem('idToken');
      localStorage.removeItem('userId');
      localStorage.removeItem('userInfo');
      context.commit('setUser', { userId: null, token: null, userInfo: {} });
    },
    async tryLogin(context) {
      const idToken = localStorage.getItem('idToken');
      const userId = localStorage.getItem('userId');
      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      if (!idToken) {
        return;
      }
      context.commit('setUser', {
        userId: userId,
        token: idToken,
        userInfo: userInfo,
      });

      const xhr = new XMLHttpRequest();
      xhr.responseType = "blob";
      xhr.onload = () => {
        const objUrl = URL.createObjectURL(xhr.response);
        context.commit('setProfileBlobUrl', objUrl)
      };
      xhr.open('GET', userInfo.profilePic);
      xhr.send();
    },
    async resetPassword(_, payload) {
      const auth = getAuth()
      await sendPasswordResetEmail(auth, payload);
    }
  },
  getters: {
    isLoggedIn(state) {
      return !!state.userId;
    },
    getProfilePic(state) {
      return state.userInfo.profilePic;
    },
    getProfileBlobUrl(state) {
      return state.profileBlobUrl;
    },
    getUserInfo(state) {
      return state.userInfo;
    },
    getUserId(state) {
      return state.userId;
    },
    getFreshAuth(state) {
      return state.freshAuth;
    },
    getProfileBlob(state) {
      return state.profileBlob;
    }
  },
};
